import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import Refund from "@/pages/Refund";
import PaymentSuccess from "@/pages/PaymentSuccess";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/success" element={<PaymentSuccess />} />
          {/* Aliases for common typos / variations of /success */}
          <Route path="/sucess" element={<PaymentSuccess />} />
          <Route path="/succes" element={<PaymentSuccess />} />
          <Route path="/successful" element={<PaymentSuccess />} />
          <Route path="/thank-you" element={<PaymentSuccess />} />
          <Route path="/thankyou" element={<PaymentSuccess />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund" element={<Refund />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
